const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';
const API_URL = `${API_BASE_URL}/recoleccion`;

// Servicios para Empleados
export const buscarEmpleadosPorNombre = async (nombre) => {
  try {
    const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';
    const response = await fetch(`${API_BASE_URL}/employee/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        limit: 20,
        offset: 1,
        query: {
          $or: [
            { nombre: { $regex: nombre, $options: 'i' } },
            { apellido: { $regex: nombre, $options: 'i' } }
          ]
        }
      })
    });

    if (!response.ok) {
      throw new Error('Error al buscar empleados');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en buscarEmpleadosPorNombre:', error);
    throw error;
  }
};

export const buscarEmpleadoPorCedula = async (cedula) => {
  try {
    const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';
    const response = await fetch(`${API_BASE_URL}/employee/by-cedula/${cedula}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Empleado no encontrado');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en buscarEmpleadoPorCedula:', error);
    throw error;
  }
};

// Servicios para Recolección de Prendas
export const createRecoleccion = async (recoleccionData) => {
  try {
    const response = await fetch(`${API_URL}/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(recoleccionData)
    });

    const data = await response.json();

    if (!response.ok || data.state === false) {
      throw new Error(data.message || 'Error al crear la recolección');
    }

    return data;
  } catch (error) {
    console.error('Error en createRecoleccion:', error);
    throw error;
  }
};

export const getInventarioPlanta = async (params = {}) => {
  try {
    const body = {
      idPlanta: params.idPlanta,
      page: params.page || 1,
      limit: params.limit || 10,
      filters: params.filters || {},
    };

    const response = await fetch(`${API_URL}/planta/inventario`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      throw new Error('Error al obtener el inventario de la planta');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en getInventarioPlanta:', error);
    throw error;
  }
};

export const getTotalesPlanta = async (params = {}) => {
  try {
    const response = await fetch(`${API_URL}/planta/totales`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ idPlanta: params.idPlanta })
    });

    if (!response.ok) {
      throw new Error('Error al obtener los totales de la planta');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en getTotalesPlanta:', error);
    throw error;
  }
};

export const getRecolecciones = async (params = {}) => {
  try {
    const body = {
      limit: params.limit || 50,
      offset: params.offset || 1,
      query: {
        ...(params.idPlanta && { 'planta.id': params.idPlanta }),
        ...(params.estado && { estado: params.estado }),
        ...(params.cedula && { 'empleado.cedula': params.cedula }),
      }
    };

    const response = await fetch(`${API_URL}/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      throw new Error('Error al obtener las recolecciones');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en getRecolecciones:', error);
    throw error;
  }
};

export const updateRecoleccion = async (recoleccionId, updateData) => {
  try {
    const response = await fetch(`${API_URL}/${recoleccionId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(updateData)
    });

    if (!response.ok) {
      throw new Error('Error al actualizar la recolección');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en updateRecoleccion:', error);
    throw error;
  }
};

const API_URL_ALISTAMIENTO = `${import.meta.env.VITE_API_URL || 'http://localhost:3000'}/alistamiento`;

export const createAlistamiento = async (data) => {
  try {
    const response = await fetch(`${API_URL_ALISTAMIENTO}/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
      body: JSON.stringify(data)
    });
    const json = await response.json();
    if (!response.ok || json.state === false) throw new Error(json.message || 'Error al crear alistamiento');
    return json;
  } catch (error) {
    console.error('Error en createAlistamiento:', error);
    throw error;
  }
};

export const getAlistamientos = async (params = {}) => {
  try {
    const body = { limit: params.limit || 20, offset: params.offset || 1, query: { ...(params.idPlanta && { 'planta.id': params.idPlanta }), ...(params.query || {}) } };
    const response = await fetch(`${API_URL_ALISTAMIENTO}/filter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
      body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error('Error al obtener alistamientos');
    return await response.json();
  } catch (error) {
    console.error('Error en getAlistamientos:', error);
    throw error;
  }
};

export const deleteRecoleccion = async (recoleccionId) => {
  try {
    const response = await fetch(`${API_URL}/${recoleccionId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Error al eliminar la recolección');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en deleteRecoleccion:', error);
    throw error;
  }
};

export const getPrendasRecoleccion = async (recoleccionId) => {
  try {
    const response = await fetch(`${API_URL}/${recoleccionId}/prendas`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Error al obtener las prendas de la recolección');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en getPrendasRecoleccion:', error);
    throw error;
  }
};

// Servicios para Gestión de Casilleros
export const verificarRecoleccion = async (recoleccionId, aprobar, observaciones = '') => {
  try {
    const response = await fetch(`${API_URL}/recolecciones/${recoleccionId}/verificar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        aprobar,
        observaciones
      })
    });

    if (!response.ok) {
      throw new Error('Error al verificar la recolección');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en verificarRecoleccion:', error);
    throw error;
  }
};

export const updatePrenda = async (recoleccionId, prendaId, prendaData) => {
  try {
    const response = await fetch(`${API_URL}/${recoleccionId}/prendas/${prendaId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(prendaData)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Error al actualizar la prenda');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en updatePrenda:', error);
    throw error;
  }
};

export const deletePrenda = async (recoleccionId, prendaId) => {
  try {
    const response = await fetch(`${API_URL}/${recoleccionId}/prendas/${prendaId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Error al eliminar la prenda');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en deletePrenda:', error);
    throw error;
  }
};

export const createPrenda = async (recoleccionId, prendaData) => {
  try {
    const response = await fetch(`${API_URL}/${recoleccionId}/prendas`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(prendaData)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Error al crear la prenda');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en createPrenda:', error);
    throw error;
  }
};

// Servicios para Entrega de Prendas
export const getPrendasPendientesEntrega = async (documento) => {
  try {
    const response = await fetch(`${API_URL}/entregas/pendientes/${documento}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Error al obtener las prendas pendientes');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en getPrendasPendientesEntrega:', error);
    throw error;
  }
};

export const getHistorialEntregas = async (params = {}) => {
  try {
    const body = {
      limit: params.limit || 10,
      offset: params.offset || 1,
      query: {
        ...(params.idPlanta && { idPlanta: params.idPlanta }),
        ...(params.cedula && { cedula: params.cedula }),
        ...(params.estado && { estado: params.estado }),
        ...(params.consecutivo && { consecutivo: params.consecutivo }),
        ...(params.fechaInicio && params.fechaFin && { 
          fechaInicio: params.fechaInicio, 
          fechaFin: params.fechaFin 
        })
      }
    };

    const response = await fetch(`${API_URL_ENTREGA}/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      throw new Error('Error al obtener el historial de entregas');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en getHistorialEntregas:', error);
    throw error;
  }
};

// Servicios para Entregas de Prendas
const API_URL_ENTREGA = `${import.meta.env.VITE_API_URL || 'http://localhost:3000'}/entrega-prendas`;

export const createEntrega = async (entregaData) => {
  try {
    const response = await fetch(API_URL_ENTREGA, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(entregaData)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Error al crear la entrega');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en createEntrega:', error);
    throw error;
  }
};

export const getEntregaById = async (id) => {
  try {
    const response = await fetch(`${API_URL_ENTREGA}/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Error al obtener la entrega');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en getEntregaById:', error);
    throw error;
  }
};

export const getEntregasByEmpleado = async (cedula) => {
  try {
    const response = await fetch(`${API_URL_ENTREGA}/empleado/${cedula}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Error al obtener entregas del empleado');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en getEntregasByEmpleado:', error);
    throw error;
  }
};

export const anularEntrega = async (id, motivoAnulacion, anuladoPor) => {
  try {
    const response = await fetch(`${API_URL_ENTREGA}/${id}/anular`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        motivoAnulacion,
        anuladoPor
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Error al anular la entrega');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en anularEntrega:', error);
    throw error;
  }
};

export const getEstadisticasEntregas = async (idPlanta, fechaInicio, fechaFin) => {
  try {
    const params = new URLSearchParams();
    if (idPlanta) params.append('idPlanta', idPlanta);
    if (fechaInicio) params.append('fechaInicio', fechaInicio);
    if (fechaFin) params.append('fechaFin', fechaFin);

    const response = await fetch(`${API_URL_ENTREGA}/estadisticas/general?${params}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Error al obtener estadísticas');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en getEstadisticasEntregas:', error);
    throw error;
  }
};

export const procesarEntrega = async (entregaData) => {
  try {
    const response = await fetch(`${API_URL}/entregas`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(entregaData)
    });

    if (!response.ok) {
      throw new Error('Error al procesar la entrega');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en procesarEntrega:', error);
    throw error;
  }
};

// Servicios para Casilleros
export const getCasilleros = async (idPlanta) => {
  try {
    const response = await fetch(`${API_URL}/casilleros/${idPlanta}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Error al obtener los casilleros');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en getCasilleros:', error);
    throw error;
  }
};

export const updateCasillero = async (casilleroId, casilleroData) => {
  try {
    const response = await fetch(`${API_URL}/casilleros/${casilleroId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(casilleroData)
    });

    if (!response.ok) {
      throw new Error('Error al actualizar el casillero');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en updateCasillero:', error);
    throw error;
  }
};

// Servicios de utilidad
export const uploadSignature = async (signatureData, entregaId) => {
  try {
    const response = await fetch(`${API_URL}/entregas/${entregaId}/firma`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        firma: signatureData
      })
    });

    if (!response.ok) {
      throw new Error('Error al subir la firma');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en uploadSignature:', error);
    throw error;
  }
};

export const generateEntregaReport = async (entregaId) => {
  try {
    const response = await fetch(`${API_URL}/entregas/${entregaId}/reporte`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Error al generar el reporte');
    }

    return await response.blob();
  } catch (error) {
    console.error('Error en generateEntregaReport:', error);
    throw error;
  }
};